// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__3onq8","input":"Search_input__3Iuo8","icon":"Search_icon__2BCti"};